import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "form__localized" };
const _hoisted_2 = ["for"];
const _hoisted_3 = ["onUpdate:modelValue", "id", "disabled", "placeholder", "required", "maxlength", "rows"];
const _hoisted_4 = ["onUpdate:modelValue", "id", "disabled", "pattern", "placeholder", "required", "maxlength"];
import { computed } from "vue";
import HtmlEditor from "./HtmlEditor.vue";
import { resolveLocales, toLocalizedValues, toValueMap } from "./LocalizedFieldUtils";
import { useFieldControl, useFieldModel } from "./useFieldControl";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlLocalized',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const { fieldOptions, emitChange, onFocus, onBlur } = useFieldControl(props, emit, 'FieldControlLocalized');
        const isHtml = computed(() => props.field.type === 'html');
        const multiline = computed(() => props.field.type === 'textarea' || props.field.type === 'code');
        const locales = computed(() => resolveLocales(fieldOptions.value, props.data));
        const values = useFieldModel(() => toValueMap(props.data, locales.value));
        function onHtmlChange(locale, value) {
            values.value[locale] = value ?? null;
            onChange();
        }
        function onChange() {
            emitChange(toLocalizedValues(props.data, locales.value, values.value));
        }
        function localeFieldId(locale) {
            return props.fieldId + '_' + locale;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locales.value, (locale, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: locale,
                        class: "form__localized-value"
                    }, [
                        _createElementVNode("label", {
                            class: "form__localized-locale",
                            for: localeFieldId(locale)
                        }, _toDisplayString(locale), 9, _hoisted_2),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        (isHtml.value)
                            ? (_openBlock(), _createBlock(HtmlEditor, {
                                key: 0,
                                "model-value": _unref(values)[locale],
                                "onUpdate:modelValue": value => onHtmlChange(locale, value),
                                onFocus: _unref(onFocus),
                                onBlur: _unref(onBlur),
                                id: localeFieldId(locale),
                                disabled: _unref(fieldOptions).disabled ?? undefined,
                                placeholder: _unref(fieldOptions).placeholder,
                                rows: _unref(fieldOptions).rows,
                                class: _normalizeClass(["form__control", 'form__control--' + __props.field.type])
                            }, null, 8, ["model-value", "onUpdate:modelValue", "onFocus", "onBlur", "id", "disabled", "placeholder", "rows", "class"]))
                            : (multiline.value)
                                ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                    key: 1,
                                    "onUpdate:modelValue": ($event) => ((_unref(values)[locale]) = $event),
                                    onInput: onChange,
                                    onFocus: _cache[0] || (_cache[0] =
                                        //@ts-ignore
                                        (...args) => (_unref(onFocus) && _unref(onFocus)(...args))),
                                    onBlur: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_unref(onBlur) && _unref(onBlur)(...args))),
                                    id: localeFieldId(locale),
                                    disabled: _unref(fieldOptions).disabled ?? undefined,
                                    placeholder: _unref(fieldOptions).placeholder ?? undefined,
                                    required: (_unref(fieldOptions).required && index === 0) || undefined,
                                    maxlength: _unref(fieldOptions).maxLength ?? undefined,
                                    rows: _unref(fieldOptions).rows ?? undefined,
                                    class: _normalizeClass(["form__control", 'form__control--' + __props.field.type])
                                }, null, 42, _hoisted_3)), [
                                    [
                                        _vModelText,
                                        _unref(values)[locale],
                                        void 0,
                                        { trim: true }
                                    ]
                                ])
                                : _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 2,
                                    "onUpdate:modelValue": ($event) => ((_unref(values)[locale]) = $event),
                                    onInput: onChange,
                                    onFocus: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_unref(onFocus) && _unref(onFocus)(...args))),
                                    onBlur: _cache[3] || (_cache[3] =
                                        //@ts-ignore
                                        (...args) => (_unref(onBlur) && _unref(onBlur)(...args))),
                                    type: "text",
                                    id: localeFieldId(locale),
                                    disabled: _unref(fieldOptions).disabled ?? undefined,
                                    pattern: _unref(fieldOptions).pattern ?? undefined,
                                    placeholder: _unref(fieldOptions).placeholder ?? undefined,
                                    required: (_unref(fieldOptions).required && index === 0) || undefined,
                                    maxlength: _unref(fieldOptions).maxLength ?? undefined,
                                    autocomplete: "off",
                                    class: "form__control"
                                }, null, 40, _hoisted_4)), [
                                    [
                                        _vModelText,
                                        _unref(values)[locale],
                                        void 0,
                                        { trim: true }
                                    ]
                                ])
                    ]));
                }), 128))
            ]));
        };
    }
});
